import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/category?type=电影", label: "电影大全" },
  { to: "/category?type=电视剧", label: "电视剧大全" },
  { to: "/category?genre=科幻", label: "科幻片库" },
  { to: "/category?genre=悬疑", label: "悬疑剧场" },
];

const aboutLinks = [
  { to: "/about", label: "关于我们" },
  { to: "/about#contact", label: "联系方式" },
  { to: "/about#disclaimer", label: "免责声明" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-film-line text-xl leading-none"></i>
            </span>
            <span className="font-heading text-xl font-black text-background-50">看片网站</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            看片网站是一个影视内容聚合与检索平台，汇集海量电影、电视剧资源，提供多维度筛选、详情介绍与个性化推荐，帮你快速找到想看的好片。
          </p>
          <p className="mt-4 max-w-md text-xs leading-relaxed text-background-400">
            本站仅提供影视作品信息展示与检索服务，不提供任何在线播放与下载功能。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-background-50">
            <Link to="/category">热门分类</Link>
          </h4>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-background-50">
            <Link to="/about">网站服务</Link>
          </h4>
          <ul className="mt-4 space-y-2.5">
            {aboutLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-6">
          <p>© 2026 看片网站 · 影视资源在线观看平台 · 演示站点</p>
          <p>本站数据均为演示内容，影视资料版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}